// Ionic & Angular Imports
import {Component} from '@angular/core';
import {Storage} from '@ionic/storage';
import {Events, AlertController, ViewController, 
        NavParams, LoadingController, Loading} from 'ionic-angular';

// Component Imports
import {BasePage} from '../base.component';

// Services
import {rsSessionSvc} from '../../services/auth.service';

@Component({
    templateUrl: 'settings.html',
    providers: []
})
export class SettingsPage extends BasePage
{
    storage: Storage = null;
    remember_me : boolean = true;
    open_recent : boolean = true;

    new_pw : string = "";
    current_pw : string = "";
    confirm_pw : string = "";

    constructor(
        private authSvc : rsSessionSvc, 
        protected alertCtrl : AlertController, 
        private navParams : NavParams, 
        private loadingCtrl : LoadingController,
        private viewCtrl : ViewController,
        private eventSystem : Events
    ){
        // Construct base class
        super( alertCtrl );

        this.storage = new Storage();
        this.storage.get('remember-me').then( ret => {
            if( ret === true ) {
                this.remember_me = true; 
            }
            else
            {
                this.remember_me = false;
            }
        });        
        this.storage.get('open-recent').then( ret => {
            if( ret === true ) {
                this.open_recent = true;
            } else {
                this.open_recent = false; 
            }
        })

    }  

    onToggleRememberMe(event) {
        this.storage.set('remember-me', event._checked );
    }    
    onToggleOpenRecent(event) {
        this.storage.set('open-recent', event._checked );
    }

    changepw(event) 
    {       
        // First let's check that the new and confirm pw fields match
        if( this.new_pw !== this.confirm_pw )
        {
            this.displayError( "The passwords entered do not match.  Please check your new password and try again.")
        }
        else 
        {
            let  loading : Loading = this.loadingCtrl.create({
                   content: 'Authenticating...',
            });
            loading.present();

            // Now let's send off our data to see if we can't update our password
            this.authSvc.changepw( this.current_pw, this.new_pw ).subscribe( result => {
                // Password updated successfully
            }, err => {
                // Error handler
                loading.dismiss().then( () => {
                    this.displayError( "Unable to change password.  Please verify that the credentials entered are correct and try again.");
                });
            }, () => {
                // At this point, we need to update our stored password, if that setting is enabled
                if( this.remember_me === true ) {
                    this.storage.set('app-password', this.new_pw );
                }

                // Reset our password fields 
                this.current_pw = "";
                this.confirm_pw = "";
                this.new_pw = "";

                // Dismiss our loading spinner
                loading.dismiss().then( () => {
                    this.displayAlert( "Password Changed", "Your password was successfully changed." );
                });        
            });                
        }
    }

    // Class method to close the modal view 
    public modalClose() {
        this.viewCtrl.dismiss();
    }

    public modalReset() {

    }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.component.ts